module.exports = __webpack_public_path__ + "img/20190907140148495.180b84d3.jpg";